import React from "react"
import { useGeneralConfig } from "../../hooks/useGeneralConfig"
import { useCartStore } from "../../hooks/useCartStore"

type Props = {
    isMenu?: boolean
}

export const BtnComprar: React.FC<Props> = ({ isMenu }) => {
    const cart = useGeneralConfig(stage => stage.cart)
    const cartLength = useCartStore(state => state.cart.length)

    const handleOpenShop = () => {
		window.dataLayer.push({
			'event': 'GAEvent',
			'event_category': 'Content',
			'event_action': 'Button',
			'event_label': `${cart.btn1} - General`,
			'interaction':'true',
			'component_name': 'Modo_Carrera_PrincipalMenu',
			'element_text': `${cart.btn1}`,
		});
        location.href = '/estadio-aguila/tienda'
    }

    return (
        <div className="ar__tadaShop_layout">
            {cart?.enabled ? (
                <div className={`ar__tadaShop__cartBtn btnComprar animate-fade ${isMenu && 'is-menu'}`} onClick={handleOpenShop}>
                    <picture className="ar__tadaShop__cartBtn--picture">
                        <img src={cart.btn1_icon} alt={cart.btn1} />
                        {
                            cartLength > 0 && (
                                <div className="ar__tadaShop__cartBtn--counter">{cartLength}</div>
                            )
                        }
                    </picture>
                    <div className="ar__tadaShop__cartBtn__name">{cart.btn1}</div>
                </div>
            ) : <div style={{display:'none'}}></div>}
        </div>

    )
}
